// extracted by mini-css-extract-plugin
export default {"float":"styles_float__9hb3D","icon":"styles_icon__ss8wQ"};